/* eslint-disable react/require-default-props */
import { type ReactElement } from 'react';
import { IoChevronBack } from 'react-icons/io5';

import Menu from '@/components/Menu';

interface MenuOption {
  onClick: () => void;
  label: string;
  icon: ReactElement;
}
interface LocationHeaderProperties {
  title: string;
  onBack?: () => void;
  menuOptions?: MenuOption[];
}

export default function LocationHeader({
  title,
  onBack,
  menuOptions,
}: LocationHeaderProperties): ReactElement {
  return (
    <header className="absolute left-0 right-0 top-2 z-elevated flex items-center justify-center p-4 text-neutral-white">
      {onBack && (
        <button
          type="button"
          aria-label="Go Back"
          className="absolute left-7 z-modal flex h-[40px] w-[40px] items-center justify-center rounded-full border-[3px] border-primary-blue-3 bg-neutral-white"
          onClick={onBack}
        >
          <IoChevronBack style={{ fontSize: '25px', color: '#002F76' }} />
        </button>
      )}
      <h1 className="font-outline-2 font-dynapuff text-[2.625rem] font-semibold leading-[1] text-secondary-pink-1">
        {title}
      </h1>
      {menuOptions && menuOptions.length > 0 && (
        <div className="absolute right-8">
          <Menu
            menuOptions={menuOptions}
            outline
            buttonStyles="w-[31px] h-[31px] border-[1.25px]"
          />
        </div>
      )}
    </header>
  );
}
